import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ObjectFieldEntity } from './object-field.entity';
import { ObjectFormatterEntity } from './object-formatter.entity';

@Index('_fk__object_field__id', ['fkObjectFieldId'], {})
@Index('_fk__object_formatter__id', ['fkObjectFormatterId'], {})
@Entity('_object_formatter__object_field')
export class ObjectFormatterObjectFieldEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__object_formatter__id',
		nullable: true,
		unsigned: true,
	})
	public fkObjectFormatterId!: number | null;

	@Column('int', {
		name: '_fk__object_field__id',
		nullable: true,
		unsigned: true,
	})
	public fkObjectFieldId!: number | null;

	@Column('varchar', { name: '_type', length: 16 })
	public type!: string;

	@Column('varchar', { name: '_property', length: 255 })
	public property!: string;

	@ManyToOne(
		() => ObjectFormatterEntity,
		(objectFormatter) => objectFormatter.objectFormatterObjectFields,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__object_formatter__id', referencedColumnName: 'id' },
	])
	public fkObjectFormatter!: ObjectFormatterEntity;

	@ManyToOne(
		() => ObjectFieldEntity,
		(objectField) => objectField.objectFormatterObjectFields,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: '_fk__object_field__id', referencedColumnName: 'id' }])
	public fkObjectField!: ObjectFieldEntity;
}
